import React from 'react';
import PropTypes from 'prop-types';
import { Image, MediaBlock } from '../../Atoms';
import { RawHtml } from '../../Utilities';

const Highlight = ({ value }) => {
  if (!value) return null;
  
  const { heading, headingLabel, subHeading, intro, image, media, image_on_right, cta } = value;
  
  return (
    <section className="section section-full">
      <div className="section__inner">
        <div className="section__body">
          
          <div className={image_on_right ? 'media-object' : 'media-object-reverse'}>
            
            {media ? (
              <div className="media-object__media">
                <div className="media-element media-element-horizontal media-element-contain">
                  <MediaBlock media={media} />
                </div>
              </div>
            ) : image ? (
              <div className="media-object__media">
                <div className="media-element media-element-horizontal">
                  <Image image={image} fit="cover" />
                </div>
              </div>
            ) : null}
            
            <div className="media-object__body">
              <div className="content-element">
                <div className="stack stack-normal">
                  {headingLabel && <div className="text-label">{headingLabel}</div>}
                  {heading && <div className="text-section-title">{heading}</div>}
                  {subHeading && <div className="text-section-support">{subHeading}</div>}
                  {intro && <div className="text-body">
                    <RawHtml html={intro} />
                    </div>}
                  {cta?.text && cta?.url && (
                    <div>
                      <a href={cta.url} className="btn btn-primary">{cta.text}</a>
                    </div>
                  )}
                </div>
              </div>
            </div>
            
          </div>
          
        </div>
      </div>
    </section>
  );
};

Highlight.propTypes = {
  value: PropTypes.shape({
    heading: PropTypes.string.isRequired,
    headingLabel: PropTypes.string,
    subHeading: PropTypes.string,
    intro: PropTypes.string.isRequired,
    image: PropTypes.object,
    media: PropTypes.object,
    image_on_right: PropTypes.bool,
    cta: PropTypes.shape({
      text: PropTypes.string,
      url: PropTypes.string,
    }),
  }),
};

export default Highlight;